export default "__VITE_ASSET__42ace6a2__"